define('viewmodels/__router',[],function() {
        'use strict';

        var routes = [{
            route: 'site*tab',
            title: 'Operations Insights',
            moduleId: 'viewmodels/site/index',
            hash: '#site',
            visible: false,
            nav: true,
        }, {
            route: 'app*tab',
            title: 'Operations Insights',
            moduleId: 'viewmodels/app/index',
            hash: '#app',
            visible: false,
            nav: true
        }];

        return {
            routes: routes
        };
    });
